import { FaEye } from "react-icons/fa";
import TableComponent from "./tableComponent";
import capitalizeFirstLetter from "./capitalizeFirstLetter";

function Tabledevices({ request, openModal }) {
  const deviceTableColumns = [
    {
      label: "Service",
      field: "serviceName",
      headerClassName: "text-left pl-2 border-l border-t border-b border-[#d3cccc]",
      className: " text-left pl-2 border-l border-t text-xs md:text-sm xl:text-base border-b border-[#d3cccc]",
      render:(item)=>(
        <>
        {capitalizeFirstLetter(item.service?.serviceName)}
        </>
      )
    },
    {
      label: "Device Type",
      field: "deviceType",
      headerClassName: "text-left pl-2 border-t border-b border-[#d3cccc]",
      className: " text-left pl-2 border-t border-b text-xs md:text-sm xl:text-base border-[#d3cccc]",
      render:(item)=>(
        <>
        {capitalizeFirstLetter(item.deviceType)}
        </>
      )
    },
    {
      label: "Brand",
      field: "brandName",
      headerClassName: "text-left pl-2  border-t border-b border-[#d3cccc]",
      className: " text-left pl-2 border-t border-b text-xs md:text-sm xl:text-base border-[#d3cccc]",
      render:(item)=>(
        <>
        {capitalizeFirstLetter(item.brandName)}
        </>
      )
    },
    {
      label: "Model",
      field: "modelNumber",
      headerClassName: "text-left pl-2  border-t border-b border-[#d3cccc]",
      className: " text-left pl-2 border-t border-b text-xs md:text-sm xl:text-base border-[#d3cccc]",
    },
    {
      label: "No. of Devices",
      field: "noOfDevices",
      headerClassName: "text-left pl-2 border-t border-b border-[#d3cccc]",
      className: " text-left pl-8 border-t border-b text-xs md:text-sm xl:text-base border-[#d3cccc]",
    },
    {
      label: "Issue start date",
      field: "issueStartDate",
      headerClassName: "text-left pl-2  border-t border-b border-[#d3cccc]",
      className: " text-left pl-2 border-t border-b text-xs md:text-sm xl:text-base border-[#d3cccc]",
      render: (item) => (
        <p>{item.issueStartDate 
            ? new Date(item.issueStartDate).toLocaleDateString("en-GB", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                  })
                  : "-"

        }</p>
      ),
    },
    {
      label: "Warranty",
      field: "warranty",
      headerClassName: "text-left pl-2 border-t border-b border-[#d3cccc]",
      className: " text-center pl-2 border-t border-b text-xs md:text-sm xl:text-base border-[#d3cccc]",
    },
    {
      label: "Problem",
      field: "problemDescription",
      headerClassName: "text-left pl-2  border-t border-b border-[#d3cccc]",
      className: "text-left pl-2  border-t border-b text-xs md:text-sm xl:text-base break-words whitespace-normal max-w-xs border-[#d3cccc]",
    },
    {
      label: "Photos",
      field: "issue_photos",
      headerClassName: "text-left pl-2 border-r border-t border-b border-[#d3cccc]",
      className: " text-left pl-2 border-r border-t text-xs md:text-sm xl:text-base border-b border-[#d3cccc]",
      render: (item) => (
        <button
          onClick={() => openModal(item.images)}
          className="text-blue-600 hover:text-blue-800 underline"
        >
          <FaEye size={18} />
        </button>
      ),
    },
  ];

  return (
    <>
      <TableComponent
        columns={deviceTableColumns}
        data={request.items || []}
        headerBg="bg-gray-100"
      />
    </>
  );
}

export default Tabledevices;
